<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Budget Status</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-plus" label="Add Budget Request" iconPos="left"></button>
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" [autoLayout]="true" responsiveLayout="scroll" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Budget Line<p-sortIcon field="code"></p-sortIcon></th>
            <th>Belongs To (Company,Department)</th>
            <th>Current Amount</th>
            <th>Budget In Hand</th>
            <th>Details</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>BDGT00000032154762019</td>
            <td>Withholding Tax Expenses</td>
            <td>Withholding Tax Expenses -Request</td>
            <td>Yes</td>
            <td>
                <p-tag styleClass="me-2 mb-1" value="Pending"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="success" value="Approved"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="info" value="Draft"></p-tag>
                <p-tag severity="danger" value="Rejected"></p-tag>
            </td>
        </tr>
    </ng-template>
</p-table>
</div>


